import Context from "shared/util/Context";

export function getValueForPromoDesign(design) {
	const attrs = {
		profilephoto: `profile photo - limit ${Context.get("likesCapTotal")}`,
		whoLikesYouTiles: "who likes you tiles",
		noLikesBoostUpsell: "no likes boost upsell",
		NEW_USERS: "NEW_USERS",
		POPULAR: "POPULAR",
	};

	return attrs[design];
}

export const PROMO_DRIVER = {
	regretSwipe: "inapp regret swipe",
};



// WEBPACK FOOTER //
// ./src/analytics/util/queryParamsMap.js